class quickAtc extends HTMLElement {
    constructor() {
        super();
        this.addToCartFn();
    }

    addToCartFn = () => {
        this.addEventListener('click', (e) => {
            const data = { quantity: 1, id: e.currentTarget.dataset.variantId };
            const pHandle = e.currentTarget.dataset.pHandle;
            this.classList.add('loading');
            fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                })
                .then((response) => response.json())
                .then((data) => {
                    this.classList.remove('loading');
                    fetch('/cart/?section_id=purchase-confirmation-popup-item', {
                            method: 'GET'
                        })
                        .then(res => res.text())
                        .then(data => {

                            // append purchase confirmation popup
                            // const productConfirmPopEle = document.querySelector('[data-purchase-confirmation-popup] .purchase-confirmation-popup__inner');
                            // const productConfirmPopWrapper = document.querySelector('[data-purchase-confirmation-popup]');
                            // productConfirmPopEle.innerHTML = data;
                            // productConfirmPopWrapper.classList.add('active');
                            // productConfirmPopWrapper.classList.add('animation--purchase-confirmation-revealed');
 const quickCartWrapper = document.querySelector('.quick-cart__wrapper');
          const quickCart = document.querySelector('.quick-cart');
           
          if (quickCartWrapper) {
            quickCartWrapper.classList.add('active');
            console.log('✓ Added active class to .quick-cart__wrapper');
          }
          if (quickCart) {
            quickCart.classList.add('is-open');
            console.log('✓ Added is-open class to .quick-cart');
          }
                            // show current added to cart product on confirmation popup
                            document.querySelector(`.purchase-confirmation-popup__item[data-product-handle="${pHandle}"]`).classList.remove('hidden');

                            // setTimeout(() => {
                            //     productConfirmPopWrapper.classList.remove('active');
                            //     productConfirmPopWrapper.classList.remove('animation--purchase-confirmation-revealed');
                            // }, 2500);

                            window.theme.offerSecSlider();
                            // freeshipping bar
                            this.freeShipStatus('[data-purchase-confirmation-popup] .free-shipping-bar');


                        })
                        .catch(err => console.error('Error:', err))


                    // append data on cart drawer
                    fetch('/cart?section_id=quick-cart', {
                            method: 'GET'
                        })
                        .then(res => res.text())
                        .then(data => {

                            const quickCartTrigger = document.querySelector('.quick-cart__container');
                            // Initialize the DOM parser
                            const parser = new DOMParser();
                            const cartData = parser.parseFromString(data, "text/html");
                            const appendData = cartData.querySelector('.quick-cart__container').innerHTML;
                            quickCartTrigger.innerHTML = appendData;

                            // cart count on header
                            const cardCount = parseInt(cartData.querySelector('.quick-cart__heading sup').textContent);
                            if (cardCount) {
                                document.querySelectorAll('[data-js-cart-count]').forEach(counter => {
                                    counter.textContent = cardCount;
                                })
                            }

                            // freeshipping bar
                            this.freeShipStatus('.quick-cart .free-shipping-bar');

                        })
                        .catch(err => console.log('Error:', err))

                })
                .catch((error) => {
                    console.error('Error:', error);
                })
        })
    }

    // freeShipStatus = ($widget) => {
    //     const shippingBar = document.querySelector($widget);
    //     if (shippingBar) {
    //         const shippingBarTitle = shippingBar.querySelector('.free-shipping-bar__message'),
    //             cartTotal = parseInt(shippingBar.dataset.cartTotal),
    //             thresholdInCents = parseInt(shippingBar.dataset.threshold),
    //             successMsg = shippingBar.dataset.freeShippingSuccessMessage,
    //             pendingMsg = shippingBar.dataset.freeShippingPendingMessage;
    //         shippingBar.classList.add('free-shipping-bar--loaded');
    //         if ((cartTotal / 100) >= thresholdInCents) {
    //             shippingBar.classList.add('free-shipping-bar--success');
    //             shippingBarTitle.innerHTML = successMsg;
    //         } else {
    //             const calcRemainAmmount = Math.abs(thresholdInCents - (cartTotal / 100)).toFixed(2);
    //             const remainAmmount = window.theme.moneyFormat.replace('{{amount}}', `${calcRemainAmmount}`)

    //             var pendMsg = pendingMsg.replace('{{ remaining_amount }}', `<span class="fs-body-bold">${remainAmmount}</span>`);
    //             console.log(pendMsg);
    //             shippingBarTitle.innerHTML = pendMsg;

    //             // progressbar on status
    //             const progressWidth = ((cartTotal / 100) < thresholdInCents) ? cartTotal / thresholdInCents : 100;
    //             shippingBar.querySelector('.free-shipping-bar__bar').style.setProperty("--progress-width", `${progressWidth}%`);

    //         }
    //     }
    // }

    freeShipStatus = ($widget) => {
        const shippingBar = document.querySelector($widget);
        if (shippingBar) {
            const shippingBarTitle = shippingBar.querySelector('.free-shipping-bar__message'),
                cartTotal = parseInt(shippingBar.dataset.cartTotal),
                thresholdInCents = parseInt(shippingBar.dataset.threshold),
                successMsg = shippingBar.dataset.freeShippingSuccessMessage,
                pendingMsg = shippingBar.dataset.freeShippingPendingMessage;
            
            console.log("freeShipStatus shippingBarTitle: ", shippingBarTitle);
            shippingBar.classList.add('free-shipping-bar--loaded');
            
            if ((cartTotal / 100) >= thresholdInCents) {
                // Free shipping achieved
                shippingBar.classList.add('free-shipping-bar--success');
                shippingBar.classList.remove('free-shipping-bar--pending');
                shippingBarTitle.innerHTML = successMsg;
            } else {
                // Free shipping pending
                shippingBar.classList.remove('free-shipping-bar--success');
                shippingBar.classList.add('free-shipping-bar--pending');
                
                const calcRemainAmmount = Math.abs(thresholdInCents - (cartTotal / 100)).toFixed(2);
                const remainAmmount = window.theme.moneyFormat.replace('{{amount}}', `${calcRemainAmmount}`);
                
                var pendMsg = pendingMsg.replace('{{ remaining_amount }}', `<span class="fs-body-bold">${remainAmmount}</span>`);
                console.log(pendMsg);
                shippingBarTitle.innerHTML = pendMsg;
                
                // FIX: Progress calculation - convert cartTotal to dollars first, then calculate percentage
                const progressWidth = ((cartTotal / 100) / thresholdInCents) * 100;
                shippingBar.querySelector('.free-shipping-bar__bar').style.setProperty("--progress-width", `${progressWidth}%`);
            }
        }
    }


}

customElements.define('quick-atc', quickAtc)